import { ADD_TOAST, REMOVE_TOAST, REMOVE_ALL_TOAST } from "../Actions/types";

const INITIAL_STATE = {
  toasts: [],
};

let toastReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_TOAST:
      return { ...state, toasts: [...state.toasts, action.payload] };

    case REMOVE_TOAST:
      let updatedToasts = state.toasts.filter(o => o.id !== action.payload);
      return { ...state, toasts: updatedToasts };

    case REMOVE_ALL_TOAST:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default toastReducer;
